import Route from '@ember/routing/route';
import { service } from '@ember/service';
import Store from '@ember-data/store';
import { type ContactRouteModel } from '../../contact';
import ContactModel from 'donor-elf-web/models/contact';

interface ContactMergeWithParams {
  mergeContactId: string;
}

export interface ContactMergeWithModel {
  keepContact: ContactModel;
  contactIds: string[];
}

export default class ContactMergeWithRoute extends Route {
  @service()
  declare contactsCache: any;
  @service()
  declare store: Store;

  model(params: ContactMergeWithParams): ContactMergeWithModel {
    let contactModel = this.modelFor(
      'funds.fund.contacts.contact',
    ) as ContactRouteModel;
    let contactIds = [contactModel.contact.id, params.mergeContactId];
    return {
      keepContact: contactModel.contact,
      contactIds,
    };
  }
}
